/**
 * ヘッダーコンポーネント
 *
 * ブランド名、セパレータ、ステージ選択コンテナ、ステージ説明、☰メニューを表示。
 * ステージ選択UIは StageSelector が headerStageWrap に自身をマウントする。
 */
export class Header {
  private container: HTMLElement;
  private descEl: HTMLElement;
  readonly stageWrap: HTMLElement;

  constructor(parentElement: HTMLElement) {
    this.container = parentElement;
    this.container.className = "header";

    // ブランド
    const brand = document.createElement("div");
    brand.className = "header__brand";
    brand.textContent = "Questile";
    this.container.appendChild(brand);

    // セパレータ
    const sep = document.createElement("div");
    sep.className = "header__sep";
    this.container.appendChild(sep);

    // ステージ選択コンテナ（StageSelectorがここにマウントされる）
    this.stageWrap = document.createElement("div");
    this.stageWrap.className = "stage-select";
    this.container.appendChild(this.stageWrap);

    // ステージ説明
    this.descEl = document.createElement("span");
    this.descEl.className = "header__desc";
    this.container.appendChild(this.descEl);

    // ☰メニュー
    const menuWrap = document.createElement("div");
    menuWrap.className = "header__menu-wrap";

    const menuBtn = document.createElement("button");
    menuBtn.className = "header__menu-btn";
    menuBtn.textContent = "\u2630";
    menuBtn.setAttribute("aria-label", "メニューを開く");
    menuWrap.appendChild(menuBtn);

    const dropdown = document.createElement("div");
    dropdown.className = "menu-dropdown";

    const items = [
      "操作ヘルプ",
      "キーボードショートカット",
      "このゲームについて",
    ];
    items.forEach((text) => {
      const item = document.createElement("button");
      item.className = "menu-dropdown__item";
      item.textContent = text;
      item.disabled = true;
      item.title = "準備中";
      dropdown.appendChild(item);
    });
    menuWrap.appendChild(dropdown);

    menuBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      dropdown.classList.toggle("open");
    });

    // 外部クリックで閉じる
    document.addEventListener("click", () => {
      dropdown.classList.remove("open");
    });

    this.container.appendChild(menuWrap);
  }

  setDescription(text: string): void {
    this.descEl.textContent = text;
  }
}
